import {
  Component,
  OnInit,
  Inject,
  Renderer2,
  ViewChild,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiService } from '../../utils/services/api.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { Person } from '../person';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-bootstrap-spinner';
import moment from 'moment'; // Import moment.js for date manipulation

import Swal from 'sweetalert2';
class Person {
  data: any[];
  draw: number;
  totalCount: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  totalCount: any;
  data1: any;
  count: any;
}

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  
})



export class TestComponent implements OnInit {
  tourForm: FormGroup;
  // MenuForm: FormGroup = this.formBuilder.group({
  //   sub_menu: ['', Validators.required],
  //   //menu_type: this.formBuilder.array([this.addAdditionalInfoGroup()])
  // }); 
  HEROES: { id: number; name: string }[];
  @ViewChildren('dap') levels: QueryList<ElementRef>;
  dragEl: any;
 // @ViewChild(DataTableDirective)
 @ViewChild('attachments') attachment: any;
 fileList: File[] = [];
listOfFiles: any[] = [];
selectedFiles?: FileList;
previews: string[] = [];
 
  constructor(private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,

    renderer: Renderer2,
    private fb: FormBuilder,
     private http: HttpClient,
      private apiService: ApiService,
    public formatter: NgbDateParserFormatter) {  }


 


  ngOnInit(): void {
    this.tourForm = this.fb.group({
      dateRanges: this.fb.array([])
    });
    this.addDateRange();
    this.HEROES = [
      { id: 1, name: 'Superman' },
      { id: 2, name: 'Batman' },
      { id: 5, name: 'BatGirl' },
      { id: 3, name: 'Robin' },
      { id: 4, name: 'Flash' },
    ];
    console.log(document.querySelectorAll('.box'))
  
  }

  get dateRanges() {
    return this.tourForm.get('dateRanges') as FormArray;
  }

  addDateRange() {
    const dateRange = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });
    this.sortDateRanges();
    this.dateRanges.push(dateRange);
    this.sortDateRanges();
  }

  sortDateRanges() {
    this.dateRanges.controls.sort((a, b) => {
      const startDateA = moment(a.value.startDate);
      const startDateB = moment(b.value.startDate);
      return startDateA.isBefore(startDateB) ? -1 : startDateA.isAfter(startDateB) ? 1 : 0;
    });
  }

  removeDateRange(index: number) {
    this.dateRanges.removeAt(index);
  }

  onFileChanged(event: any) {
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      this.fileList.push(selectedFile);
      this.listOfFiles.push(selectedFile.name)
  }

  this.attachment.nativeElement.value = '';
}

submitTour() {
  this.sortDateRanges();
  setTimeout(() => {
    if (this.tourForm.valid) {
      const tourData = this.tourForm.value;
      console.log(tourData)
      // this.apiService.createTour(tourData).subscribe(
      //   response => {
      //     console.log('Tour created successfully:', response);
      //     // Reset the form or navigate to another page
      //   },
      //   error => {
      //     console.error('Error creating tour:', error);
      //     // Handle error
      //   }
      // );
    }
    
  }, 2000);
  
}

selectFiles(event: any): void {
  // this.message = [];
  // this.progressInfos = [];
  this.selectedFiles = event.target.files;

  this.previews = [];
  if (this.selectedFiles && this.selectedFiles[0]) {
    const numberOfFiles = this.selectedFiles.length;
    for (let i = 0; i <= numberOfFiles  - 1; i++) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.previews.push(e.target.result);
      };

      reader.readAsDataURL(this.selectedFiles[i]);

      this.attachment.nativeElement.value = '';
    }
  }
}



removeSelectedFile(index) {
 // Delete the item from fileNames list
 this.listOfFiles.splice(index, 1);
 // delete file from FileList
 this.fileList.splice(index, 1);
}
  ngAfterViewInit() {
    if (this.levels['_results']) {
      // console.log(this.levels['_results'])
      var items = this.levels['_results'].map((el) => el.nativeElement);
      // console.log(items)
      var dragEl = null;

      function handleDragStart(e) {
        this.style.opacity = '0.4';

        dragEl = this;
        console.log("handleDragStart from c",this);
        console.log(this, this.innerHTML);

        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text', this.innerHTML);
      }

      function handleDragOver(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }

        e.dataTransfer.dropEffect = 'move';

        return false;
      }

      function handleDragEnter(e) {
        this.classList.add('over');
      }

      function handleDragLeave(e) {
        this.classList.remove('over');
      }

      function handleDrop(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }

        if (dragEl != this) {
          dragEl.innerHTML = this.innerHTML;
          this.innerHTML = e.dataTransfer.getData('text');
        }

        return false;
      }

      function handleDragEnd(e) {
        this.style.opacity = '1';

        items.forEach(function (item) {
          item.classList.remove('over');
        });
      }

      items.forEach(function (item) {
        item.addEventListener('dragstart', handleDragStart);
        item.addEventListener('dragenter', handleDragEnter);
        item.addEventListener('dragover', handleDragOver);
        item.addEventListener('dragleave', handleDragLeave);
        item.addEventListener('drop', handleDrop);
        item.addEventListener('dragend', handleDragEnd);
      });
    }
  }

  handleDragStart(e) {
    console.log('e', e);
    // e.style.opacity = '0.4';

    // this.dragEl = e;
    // console.log(this, e.innerHTML);

    // e.dataTransfer.effectAllowed = 'move';
    // e.dataTransfer.setData('text', e.innerHTML);
  }

  handleDragOver(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }

    e.dataTransfer.dropEffect = 'move';

    return false;
  }

  handleDragEnter(e) {
    e.classList.add('over');
  }

  handleDragLeave(e) {
    e.classList.remove('over');
  }

  handleDrop(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }

    if (this.dragEl != e) {
      this.dragEl.innerHTML = e.innerHTML;
      e.innerHTML = e.dataTransfer.getData('text');
    }

    return false;
  }

  handleDragEnd(e) {
    e.style.opacity = '1';
  }
  
 
}
